<template>
  <div class="container-fluid section">
    <div class="row">
      <div class="col">
        <h2>Saved Charts</h2>
      </div>
    </div>
    <div class="row" >
      <div class="chart-holder" v-for="chart in charts" :class="chart.className" :key="chart.userChart_id" @click="goToChart(chart)">
        <div class="chart-row">
            <div class="chart-label">
              <p><strong>{{chart.name}}</strong></p>
            </div>
            <div class="chart-actions">
                <dropdown-confirmation
                    v-show="chart.showDelete"
                    triggerBtnClass="btn-delete btn-sm"
                      triggerBtnHtml='<i class="fa fa-trash"></i>'
                      confirmBtnClass="btn-danger"
                      confirmBtnHtml='<i class="fa fa-remove"></i>&nbsp;&nbsp;Delete'
                      @confirm="deleteChart(chart)"
                ></dropdown-confirmation>


                <share-chart
                    :chart="chart"
                    @refetch="shareChart"
                ></share-chart>
            </div>


          </div>
        <div class="chart-adjustments group" v-if="chart.Chart && chart.Chart.userChartDetails">
            <span style="float: left; padding: 5px; border-right: 1px solid #e2e2e2;">
                Adjust {{chart.Chart.userChartDetails.x_field.display_name}}:&nbsp;&nbsp;</span>
            <timeframe
                v-if="chart.Chart.userChartDetails.x_field.field_type == 'daterange'"
                :timeframes="timeframes"
                :groups="groups"
                v-model="chart.Chart.userChartDetails.x_field.search"
                @input="updateChart(chart)"
            >
            </timeframe>


        </div>

        <div class="canvas-holder" >

            <canvas class="chart-canvas"  :id="'chart_' + chart.userChart_id" > </canvas>
            <span class="chart-canvas" :id="'value_' + chart.userChart_id" style="text-align: center"  v-show="chart.Chart && chart.Chart.userChartDetails.chart_type == 'Value'">
                <span class="displayNum">
                    {{ chart.Chart | getFirstKey }}<br />
                    <span style="color: #a0a0a0; line-height: 18px; font-size: 18px;">{{ chart.Chart | getChartLabel }}</span>
                </span>
            </span>

        </div>
        <div class="chart-loading" v-show="!chartDivs[chart.userChart_id]">
          <pulse-loader color="#5e9cd3"></pulse-loader>
        </div>
        </div>

      </div>
    </div>
</template>

<script type="text/babel">

  function formatLabel(str, maxwidth){
    var sections = [];

    var words = str.split(" ");
    var temp = "";


    words.forEach(function(item, index){
      if(temp.length > 0) {
        var concat = temp + ' ' + item;

        if(concat.length > maxwidth){
          sections.push(temp);
          temp = "";
        }
        else {
          if(index == (words.length-1)) {
            sections.push(concat);
            return;
          } else {
            temp = concat;
            return;
          }
        }
      }

      if(index == (words.length-1)) {
        sections.push(item);
        return;
      }

      if(item.length < maxwidth) {
        temp = item;
      }
      else {
        sections.push(item);
      }
    });
    return sections;
  }


  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  var Promise = require("bluebird");
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
  import ShareChart from './ShareChart.vue';
  import Timeframe from '../assets/Timeframe.vue';
  import RangeFilter from '../assets/RangeFilter.vue';

  export default {
    name: 'SavedCharts',
    data: function () {
      return {
        charts: [],
        chart: null,
        chartDivs:{},
        aspectRatio: 9/4,
        timeframes:[ 'Month To Date', 'Last 30 days', 'Last Month', 'Quarter To Date', 'Last Quarter', 'Year To Date', 'Last One Year', 'Last Year', 'Lifetime', 'Custom'],
        groups: [
          'Date', 'Week', 'Month', 'Year'
        ],

        datefield: {
            timeframe: '',
            start: '',
            end: '',
            group: ''
        }

      }
    },
    components: {
        DropdownConfirmation,
        PulseLoader,
        ShareChart,
        Timeframe,
        RangeFilter
    },
    created(){
        var _this = this;
        window.addEventListener('resize', function() {
            // _this.resizeCharts();
        });

    },
    mounted(){
      this.fetchData();
    },
    filters:{
        getChartLabel(chartData){
            if(!chartData || !chartData.userChartDetails ) return '-';
            var obj = chartData.userChartDetails.datapoints;
            return Object.keys(obj)[0];

        },
        getFirstKey(chartData){
            if(!chartData || !chartData.userChartDetails ) return '-';
            var obj = chartData.userChartDetails.datapoints;
            return obj[Object.keys(obj)[0]];
        }
    },
    methods:{
        updateChart(chart){


            if(this.chartDivs[chart.userChart_id]){
                this.chartDivs[chart.userChart_id].chart.destroy();
                delete this.chartDivs[chart.userChart_id];
            }

            this.loadChart(chart, chart.Chart.userChartDetails.x_field);

        },
        resizeCharts: _.debounce(function(){
            var _this = this;
            var chartDivs = document.getElementsByClassName("chart-holder");

            for(var i = 0; i < chartDivs.length - 1; i++){
                var width = chartDivs[i].offsetWidth;
                chartDivs[i].style.height = (width / _this.aspectRatio) + 'px';
            };
        }, 500),
        goToChart(chart){

        },

        shareChart(chart){

            var charts = this.charts.filter(c => { return c.userChart_id == chart.userChart_id});
            if(charts.length){
                this.$set(this.charts[this.charts.indexOf(charts[0])], 'shared', (chart.userShares.length || chart.universal));
                this.$set(this.charts[this.charts.indexOf(charts[0])], 'userShares', chart.userShares);
                this.$set(this.charts[this.charts.indexOf(charts[0])], 'universal', chart.universal);
            }
        },

        deleteChart(chart){
            this.$send(this, 'userChartDelete',chart).then(r => {
                this.fetchData();
            });
          },

        fetchData(){
            this.$send(this, 'userCharts').then(r => {
                this.charts = r.userCharts;
                this.showCharts();
            });
        },

        showCharts(){
            var _this = this;
            this.charts.forEach(function(c){
              _this.loadChart.call(_this, c);
            });
          },

        getChartDetails(c, x_field, y_field){
            var _this = this;
            return Promise.resolve().then(function(){
                return _this.$send(_this, 'userChartDetails', {
                    userChart_id: c.userChart_id,
                    x_field: x_field || '',
                    y_field: y_field || ''
                }).then(r =>{
                    return r;
                });
            });

        },

        loadChart(c, x_field, y_field){
            var _this = this;
            var promises = [];

            this.getChartDetails(c, x_field, y_field).then(function(chart){

                _this.$set(c, 'Chart', chart);
                var chartDiv = '';
                switch(chart.chart_type){
                    case "Value":
                        chartDiv = document.getElementById("value_" + chart.userChartDetails.userChart_id);
                        break;
                    default:
                        chartDiv = document.getElementById("chart_" + chart.userChartDetails.userChart_id);
                        break;
                }

                chartDiv.height = 125;

                var labels = [];
                var data = [];

                if(!chart.userChartDetails.datapoints) return null;

                var keys = Object.keys(chart.userChartDetails.datapoints);

                for (var k in keys){
                    labels.push(keys[k]);
                    data.push(chart.userChartDetails.datapoints[keys[k]]);
                }

                c.className = '';
                if(data.length >= 10){
            //        c.className = 'lg';
                }

                _this.$set(_this.chartDivs, chart.userChartDetails.userChart_id,  {
                    chartDiv: chartDiv,
                    chart: {},
                    loaded: true
                });

                if(!chart.userChartDetails.chart_type) return false;




                  promises.push(
                    _this.renderChart(chart.userChartDetails.userChart_id, chart.userChartDetails.chart_type ,data,labels)
                  );

              return Promise.all(promises);

            });
          },
          renderChart(chart_id, type, data, labels){
            var _this = this;
            switch(type){
              case 'Pie':
                  _this.renderPieChart(chart_id,  data, labels);
                  break;
              case 'Bar':
                _this.renderBarChart(chart_id, data, labels);
                break;
              case 'Line':
                _this.renderLineChart(chart_id, data, labels);
                break;
              case 'Value':
                _this.renderValueChart(chart_id, data, labels);
                  break;
              default:
                return false;
            }
          },
          renderPieChart(chart_id, data, labels){

            this.chartDivs[chart_id].chart = new Chart(this.chartDivs[chart_id].chartDiv,{
              type: 'doughnut',
              data: {
                labels:labels,
                datasets: [{
                  data: data,
                  backgroundColor: [
                    "#FF6384",
                    "#4BC0C0",
                    "#FFCE56",
                    "#E7E9ED",
                    "#36A2EB",
                    "#FF6384",
                    "#4BC0C0",
                    "#FFCE56",
                    "#E7E9ED",
                    "#36A2EB"
                  ],
                }]
              },
              options:{
                legend: {

                  position: 'left'
                },
                legendCallback:function(){

                }
              }

            });

          },
          renderBarChart(chart_id, data, labels){

            this.chartDivs[chart_id].chart = new Chart(this.chartDivs[chart_id].chartDiv, {
              type: "bar",
              data:{
                labels: labels.map(function(label){
                  // return formatLabel(label, 3)
                  return label;
                }),
                datasets: [{
                  data: data,
                  backgroundColor: [
                    "#FF6384",
                    "#4BC0C0",
                    "#FFCE56",
                    "#E7E9ED",
                    "#36A2EB",
                    "#FF6384",
                    "#4BC0C0",
                    "#FFCE56",
                    "#E7E9ED",
                    "#36A2EB",
                    "#FF6384",
                    "#4BC0C0",
                    "#FFCE56",
                    "#E7E9ED",
                    "#36A2EB"
                  ],
                  borderCapStyle: 'butt',
                  borderWidth: 1,
                  fill: false
                }]
              },
              options:{
                legend: {
                  display: false
                },

                tooltips:{
                  backgroundColor: 'rgba(245,247,248,1)',
                  bodyFontColor: '#586266',
                  titleFontColor: '#586266',
                  displayColors:false,
                  callbacks:{
                    label: function(tooltipItem, data){
                      return tooltipItem.yLabel;
                    }
                  }
                }
              }
            });

          },

          renderLineChart(chart_id, data, labels){
            this.chartDivs[chart_id].chart = new Chart(this.chartDivs[chart_id].chartDiv, {
              type: "line",
              data:{
                labels: labels.map(function(label){
                  return formatLabel(label, 3)
                }),
                datasets: [{
                  data: data,
                  backgroundColor: "#36A2EB",
                  borderCapStyle: 'butt',
                  borderWidth: 1,
                  fill: false
                }]
              },
              options:{
                legend: {
                  display: false
                },
                tooltips:{
                  backgroundColor: 'rgba(245,247,248,1)',
                  bodyFontColor: '#586266',
                  titleFontColor: '#586266',
                  displayColors:false,
                  callbacks:{
                    label: function(tooltipItem, data){
                      return "$" + tooltipItem.yLabel.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                    }
                  }
                }
              }
            });
          },
          renderValueChart(chart_id, data, labels){
                console.log("Data", data);
                console.log("Labels", labels);
                console.log("Chart ID", chart_id);
            }
        }

  }


</script>
<style scoped>
  .chart-loading {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 100px;
  }


  .chart-legend li span{
      display: inline-block;
      width: 5px;
      height: 12px;
      margin-right: 10px;
  }

  .chart-holder{
    position: relative;

    width: 100%;
    margin:10px;
    border: 1px solid #e2e2e2

  }
  .chart-label{
      padding: 3px;
  }
  .chart-label p{
      margin: 0;
      padding: 0;
  }
    .canvas-holder{
        width: 100%;
        min-height: 100px;
        box-sizing: border-box;
        bottom: 0;
        position: relative;


    }
  .chart-canvas{
      padding: 20px;
  }
  .chart-row {
      width: 100%;
      background: #f5f5f5;
      padding: 10px;
      border-bottom: 1px solid #e2e2e2;
  }

  .chart-adjustments {
      width: 100%;
      background: #ffffff;
      padding: 10px;
      border-bottom: 1px solid #e2e2e2;
  }

  .chart-row:after {
      content: "";
      display: table;
      clear: both;
  }
  .chart-label {
      float: left;
  }
    .chart-actions{
        float: right
    }



  @media ( max-width: 768px ){
      .chart-holder{
        width: 100%;
      }
  }

  @media ( max-width: 991px ){
      .chart-holder{

      }
  }


  @media ( min-width: 1200px ){
      .chart-holder{
        width: 48%;
        margin: 1%;
      }
      .chart-holder.lg{
          width: 100%;
          margin: 10px;
      }
  }

</style>



// WEBPACK FOOTER //
// SavedCharts.vue?2869c2a2